import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogContent,
  Grid,
} from "../../../../components";

function HistoricoEnvios({
  destinatarios,
  destinatariosColunas,
  openHistorico,
  handleCloseHistoricoDialog,
  buscarDestinatarios,
  rowCount,
}) {
  const sendServerDatagrid = (props) => {
    const { filtros, tipoFiltro } = props;
    if (tipoFiltro === "simples") {
      buscarDestinatarios(filtros);
    }
  };

  return (
    <Dialog
      maxWidth={"xl"}
      fullWidth
      open={openHistorico}
      onClose={handleCloseHistoricoDialog}
    >
      <DialogContent>
        <CardHeader
          title="Histórico de Envios"
          action={
            <Button
              onClick={handleCloseHistoricoDialog}
              variant="contained"
              color="padrao"
            >
              fechar
            </Button>
          }
        />
        <Grid container spacing={4}>
          <Grid className="mt-2" item xs={12}>
            <DataGrid
              rows={destinatarios}
              columns={destinatariosColunas}
              rowCount={rowCount}
              paginationMode={"server"}
              sendServer={(props) => sendServerDatagrid(props)}
              disableAcoes
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default HistoricoEnvios;
